/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CustomOption/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function CustomOption({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/ProviderCount/Content/Content/CustomOption"
  
}) {
let itemEmploymentContractPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'item',
path: 'employment_contract.person.first_name',
})
let itemEmploymentContractPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'item',
path: 'employment_contract.person.last_name',
})
let aggregateData = fromAggregate.join(itemEmploymentContractPersonFirstNameValueData, itemEmploymentContractPersonLastNameValueData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="item.employment_contract.person.first_name"
 data="item.employment_contract.person.last_name"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}